export default "__VITE_ASSET__DAWsR2UA__"